import React from 'react';
import { createSvgIcon } from '@material-ui/core/utils';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M11.094 8.464l-4.777 5.499c-.312.36-.384.852-.186 1.284s.616.702 1.092.702h9.554c.476 0 .894-.269 1.092-.702a1.189 1.189 0 00-.186-1.284l-4.777-5.499a1.2 1.2 0 00-1.812 0z"
}), 'ArrowUp');